var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow || _vm.isInlinePin)?_c('div',{class:_vm.isHidden ? 'is_hidden' : ''},[(_vm.isInline || _vm.isInlinePin)?_c('div',[_vm._t("dialog-content")],2):_c('div',{staticClass:"overlay-panel",class:{
      'overlay-panel-right': _vm.showInRight,
      'overlay-panel-left': _vm.showInLeft,

    },style:({ zIndex: _vm.baseZIndex }),attrs:{"data-index":_vm.baseZIndex,"data-uid":_vm._uid}},[_c('div',{staticClass:"dialog-container",style:({
        top: _vm.dialogContentTop,
        width: _vm.width + 'vw !important',
        left:  _vm.left + 'vw !important',
      }),attrs:{"id":_vm.dialogId},on:{"scroll":function($event){return _vm.handleScrollDialog($event)}}},[_vm._t("sticky-bar"),_vm._v(" "),_c('div',{ref:"dialogContent",staticClass:"dialog-content-container",style:(_vm.isEmbed && _vm.iframeParentHeight
            ? ("max-height: " + _vm.maxHeightDialogContent + "px;")
            : ''),on:{"scroll":function($event){return _vm.handleScrollDialog($event)}}},[_vm._t("dialog-content")],2),_vm._v(" "),(!_vm.hideCloseBtn)?_c('div',{staticClass:"close-button-container",class:{ 'btn-bg-white': _vm.useWhiteBgCloseButton },style:({
          zIndex: _vm.baseZIndex,
          top: _vm.topCloseBtn,
          right: _vm.rightCloseBtn,
        })},[_c('i',{staticClass:"material-icons close-button-tour-handle",on:{"click":function($event){return _vm.handleCloseDialog()}}},[_vm._v(" cancel ")])]):_vm._e()],2)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc823762","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/global-dialogs/ModalDialog.vue
// module id = 535
// module chunks = 38